import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ContactezNosExperts from "./sections/ContactezNosExperts";
import MedicalConsultationRequest from "@/pages/Home/sections/MedicalConsultationRequest";
import PrivacyNotice from "./sections/PrivacyNotice";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ContactezNosExperts />
      <MedicalConsultationRequest />
      <PrivacyNotice />
      <Footer />
    </div>;
}